export default "__VITE_ASSET__c7188c1d__"